import * as React from "react";
const SvgCheck = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12.3334 1L5.00002 8.33333L1.66669 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgCheck;
